import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { DataLayerAnalyticsService } from '../../services/analytics/data-layer.service';
import { MembershipCardService } from '../../services/api/membership-card.service';
import * as OverviewActions from '../actions/api.actions';

@Injectable()
export class MembershipCardEffects {
  loadMembershipCard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OverviewActions.loadMembershipCard),
      switchMap(() =>
        this.data.getMembershipCard().pipe(
          map((content) =>
            OverviewActions.loadMembershipCardSuccess({
              membershipCards: {
                id: 'membership-card-data',
                membershipCard: content
              }
            })
          ),
          catchError((error: HttpErrorResponse) => {
            this.dataLayer.setErrorData(error);
            return of(
              OverviewActions.loadMembershipCardFailure({
                error: {
                  id: 'membership-card-data-error',
                  membershipCardError: 'membership'
                }
              })
            );
          })
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly data: MembershipCardService,
    protected dataLayer: DataLayerAnalyticsService
  ) {}
}
